(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-bottombar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBnav(root) {
      if (root.__msBnavInit) return;
      root.__msBnavInit = true;

      // Reservar espacio para que la barra no tape el contenido
      function applySpace() {
        var reserve = root.getAttribute('data-reserve') === 'true';
        var isMobile = window.matchMedia('(max-width: 900px)').matches;
        var onDesktop = root.classList.contains('ms-bnav--desktop');
        var bar = root.querySelector('.ms-bnav__row');
        var h = bar ? bar.offsetHeight : root.offsetHeight;
        if (reserve && (isMobile || onDesktop)) {
          document.body.style.paddingBottom = h + 'px';
        } else {
          document.body.style.paddingBottom = '';
        }
      }
      applySpace();
      window.addEventListener('resize', applySpace);

      // Ocultar al bajar, mostrar al subir
      if (root.getAttribute('data-autohide') === 'true') {
        var lastY = window.pageYOffset || 0;
        var threshold = 80;
        var delta = 6;
        var ticking = false;
        function update() {
          var y = window.pageYOffset || 0;
          if (root.classList.contains('is-sheet-open') || root.classList.contains('is-search-open')) { ticking = false; return; }
          if (y < threshold) { root.classList.remove('is-hidden'); }
          else if (y > lastY + delta) { root.classList.add('is-hidden'); }
          else if (y < lastY - delta) { root.classList.remove('is-hidden'); }
          lastY = y;
          ticking = false;
        }
        window.addEventListener('scroll', function () {
          if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
      }

      // Paneles (menú y búsqueda)
      function lock() { document.documentElement.style.overflow = 'hidden'; }
      function unlock() { document.documentElement.style.overflow = ''; }
      function closeAll() { root.classList.remove('is-sheet-open'); root.classList.remove('is-search-open'); unlock(); }
      function openMenu() { root.classList.remove('is-search-open'); root.classList.add('is-sheet-open'); lock(); }
      function openSearch() {
        root.classList.remove('is-sheet-open');
        root.classList.add('is-search-open');
        lock();
        var input = root.querySelector('[data-search-input]');
        if (input) { setTimeout(function () { input.focus(); }, 280); }
      }

      var menuOpeners = root.querySelectorAll('[data-sheet-open]');
      for (var mo = 0; mo < menuOpeners.length; mo++) menuOpeners[mo].addEventListener('click', openMenu);
      var searchOpeners = root.querySelectorAll('[data-search-open]');
      for (var so = 0; so < searchOpeners.length; so++) searchOpeners[so].addEventListener('click', openSearch);
      var closers = root.querySelectorAll('[data-panel-close]');
      for (var cl = 0; cl < closers.length; cl++) closers[cl].addEventListener('click', closeAll);

      var subs = root.querySelectorAll('[data-submenu-toggle]');
      for (var ss = 0; ss < subs.length; ss++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var li = btn.parentNode;
            var sub = li.querySelector('.ms-bnav__submenu');
            var isOpen = btn.classList.toggle('is-open');
            if (sub) { if (isOpen) { sub.classList.add('is-open'); } else { sub.classList.remove('is-open'); } }
          });
        })(subs[ss]);
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    }

    function initAll() {
      var all = document.querySelectorAll('.ms-bnav');
      for (var i = 0; i < all.length; i++) initBnav(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var AMT = '{' + '{amount}}';
    var DEFAULT_FMT = '$' + AMT;
    function formatMoney(cents, format) {
      format = format || DEFAULT_FMT;
      function fmt(num, precision, thousands, decimal) {
        if (num == null || isNaN(num)) num = 0;
        var val = (num / 100).toFixed(precision);
        var parts = val.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholder);
      var value;
      switch (match && match[1]) {
        case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
        default: value = fmt(cents, 2, ',', '.');
      }
      return format.replace(placeholder, value);
    }
    function esc(s) {
      return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function initCart(root) {
      if (root.__msCartInit) return;
      root.__msCartInit = true;

      var fmt = root.getAttribute('data-money-format') || DEFAULT_FMT;
      var shipOn = root.getAttribute('data-free-ship-on') === 'true';
      var threshold = (parseFloat(root.getAttribute('data-free-ship')) || 0) * 100;
      var progText = root.getAttribute('data-ship-prog') || '';
      var doneText = root.getAttribute('data-ship-done') || '';
      var skuFree = root.getAttribute('data-ship-sku') || '';
      var skuText = root.getAttribute('data-ship-sku-text') || '';
      var pwoText = root.getAttribute('data-ship-pwo-text') || '';
      var openOnAdd = root.getAttribute('data-open-on-add') === 'true';

      var overlay = root.querySelector('[data-cart-overlay]');
      var itemsEl = root.querySelector('[data-cart-items]');
      var emptyEl = root.querySelector('[data-cart-empty]');
      var footerEl = root.querySelector('[data-cart-footer]');
      var subtotalEl = root.querySelector('[data-cart-subtotal]');
      var countLabel = root.querySelector('[data-cart-count-label]');
      var barWrap = root.querySelector('[data-ship-bar-wrap]');
      var barFill = root.querySelector('[data-ship-bar-fill]');
      var barText = root.querySelector('[data-ship-text]');
      var upsellsWrap = root.querySelector('[data-upsells]');
      var appliedEl = root.querySelector('[data-applied]');
      var subtotalOrig = root.querySelector('[data-subtotal-orig]');
      var savingsEl = root.querySelector('[data-savings]');
      var discToggle = root.querySelector('[data-discount-toggle]');
      var discForm = root.querySelector('[data-discount-form]');
      var discInput = root.querySelector('[data-discount-input]');
      var discApply = root.querySelector('[data-discount-apply]');
      var discMsg = root.querySelector('[data-discount-msg]');
      var loaded = false;

      function open() { root.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
      function close() { root.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

      function syncBubbles(count) {
        if (countLabel) countLabel.textContent = count;
        var bubbles = document.querySelectorAll('.ms-hd__cart-count, .ms-bnav__badge');
        for (var i = 0; i < bubbles.length; i++) {
          bubbles[i].textContent = count;
          bubbles[i].style.display = count > 0 ? '' : 'none';
        }
      }

      function itemHTML(it) {
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var img = it.image ? '<img src="' + sized(it.image, 160) + '" alt="">' : '';
        return '' +
          '<div class="ms-cart__item" data-line-key="' + esc(it.key) + '">' +
            '<a class="ms-cart__item-img" href="' + esc(it.url) + '">' + img + '</a>' +
            '<div class="ms-cart__item-main">' +
              '<a class="ms-cart__item-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              (variant ? '<span class="ms-cart__item-variant">' + esc(variant) + '</span>' : '') +
              '<div class="ms-cart__item-row">' +
                '<div class="ms-cart__stepper">' +
                  '<button type="button" data-dec data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Quitar uno">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-inc data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Agregar uno">+</button>' +
                '</div>' +
                '<span class="ms-cart__item-price">' + formatMoney(it.final_line_price, fmt) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="ms-cart__item-remove" data-remove data-key="' + esc(it.key) + '" aria-label="Eliminar">×</button>' +
          '</div>';
      }

      function updateUpsells(cart) {
        if (!upsellsWrap) return;
        var ids = {};
        for (var i = 0; i < cart.items.length; i++) ids[cart.items[i].product_id] = true;
        var cards = upsellsWrap.querySelectorAll('[data-up]');
        var visible = 0;
        for (var j = 0; j < cards.length; j++) {
          var pid = parseInt(cards[j].getAttribute('data-product-id'), 10);
          if (ids[pid]) { cards[j].classList.add('ms-cart__up--hidden'); }
          else { cards[j].classList.remove('ms-cart__up--hidden'); visible++; }
        }
        upsellsWrap.style.display = visible > 0 ? '' : 'none';
      }

      function recImg(p) {
        var fi = p.featured_image;
        if (typeof fi === 'string' && fi) return fi;
        if (fi && (fi.src || fi.url)) return fi.src || fi.url;
        if (p.images && p.images[0]) { var f = p.images[0]; return (typeof f === 'string') ? f : (f.src || f.url || ''); }
        return '';
      }
      function recVariant(p) {
        if (p.variants && p.variants.length) {
          for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].available) return p.variants[k].id; }
          return p.variants[0].id;
        }
        return p.id;
      }
      function buildRecCard(p) {
        var src = recImg(p);
        var img = src ? '<img src="' + sized(src, 160) + '" alt="" loading="lazy">' : '';
        return '<div class="ms-cart__up" data-up data-product-id="' + p.id + '">' +
          '<div class="ms-cart__up-img">' + img + '</div>' +
          '<span class="ms-cart__up-title">' + esc(p.title) + '</span>' +
          '<span class="ms-cart__up-price">' + formatMoney(p.price, fmt) + '</span>' +
          '<button type="button" class="ms-cart__up-add" data-upsell-add data-id="' + recVariant(p) + '">+ Agregar</button>' +
          '</div>';
      }
      function loadRecs(cart) {
        if (!upsellsWrap) return;
        if (upsellsWrap.getAttribute('data-upsells-manual') === 'true') return;
        if (!cart.items.length) { upsellsWrap.style.display = 'none'; return; }
        if (upsellsWrap.__recsDone) return;
        upsellsWrap.__recsDone = true;
        var pid = cart.items[0].product_id;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        fetch(base + 'recommendations/products.json?product_id=' + pid + '&limit=6', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data && data.products) ? data.products : [];
            var track = upsellsWrap.querySelector('.ms-cart__upsells-track');
            if (!track) return;
            var h = '';
            for (var i = 0; i < prods.length; i++) { if (prods[i].available !== false) h += buildRecCard(prods[i]); }
            if (h) { track.innerHTML = h; upsellsWrap.style.display = ''; updateUpsells(cart); }
            else { upsellsWrap.style.display = 'none'; }
          })
          .catch(function () { upsellsWrap.style.display = 'none'; });
      }

      function renderDiscounts(cart) {
        var apps = cart.cart_level_discount_applications || cart.discount_applications || [];
        if (appliedEl) {
          if (apps.length) {
            var h = '';
            for (var d = 0; d < apps.length; d++) {
              h += '<div class="ms-cart__applied-row"><span class="ms-cart__applied-tag">' + esc(apps[d].title) + '</span><span class="ms-cart__applied-amt">−' + formatMoney(apps[d].total_allocated_amount, fmt) + '</span></div>';
            }
            appliedEl.innerHTML = h;
            appliedEl.style.display = '';
          } else {
            appliedEl.innerHTML = '';
            appliedEl.style.display = 'none';
          }
        }
        var saved = cart.total_discount || 0;
        if (subtotalOrig) {
          if (saved > 0) { subtotalOrig.textContent = formatMoney(cart.original_total_price, fmt); subtotalOrig.style.display = ''; }
          else { subtotalOrig.style.display = 'none'; }
        }
        if (savingsEl) {
          if (saved > 0) { savingsEl.textContent = '🎉 Ahorras ' + formatMoney(saved, fmt); savingsEl.style.display = ''; }
          else { savingsEl.style.display = 'none'; }
        }
      }

      function render(cart) {
        syncBubbles(cart.item_count);
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '';
          itemsEl.style.display = 'none';
          emptyEl.style.display = 'block';
          footerEl.style.display = 'none';
          if (barWrap) barWrap.style.display = 'none';
        } else {
          var html = '';
          for (var i = 0; i < cart.items.length; i++) html += itemHTML(cart.items[i]);
          itemsEl.innerHTML = html;
          itemsEl.style.display = '';
          emptyEl.style.display = 'none';
          footerEl.style.display = '';
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, fmt);
          renderDiscounts(cart);
          if (shipOn && barWrap) {
            barWrap.style.display = '';
            // Los SKU con envío incluido (perfil de envío propio) no cuentan para el umbral
            var incluido = 0, soloIncluido = cart.items.length > 0, soloPwo = cart.items.length > 0;
            for (var k = 0; k < cart.items.length; k++) {
              var skuK = cart.items[k].sku || '';
              if (skuFree && skuK.indexOf(skuFree) === 0) incluido += cart.items[k].final_line_price;
              else soloIncluido = false;
              if (!/^PWO-/.test(skuK)) soloPwo = false;
            }
            var base = cart.total_price - incluido;
            var remaining = threshold - base;
            if (incluido > 0 && soloIncluido) {
              barFill.style.width = '100%';
              barText.textContent = skuText || doneText;
            } else if (pwoText && soloPwo) {
              // carrito solo de Pre-Work Out por debajo del umbral: sin cuenta regresiva, solo el mensaje de las 2 bolsas
              barFill.style.width = '0%';
              barText.textContent = pwoText;
            } else if (remaining <= 0) {
              barFill.style.width = '100%';
              barText.textContent = doneText;
            } else {
              barFill.style.width = Math.min(100, (base / threshold) * 100) + '%';
              barText.textContent = progText.split('[monto]').join(formatMoney(remaining, fmt));
            }
          }
        }
        updateUpsells(cart);
        renderCombo(cart);
        loadRecs(cart);
      }

      function getCart(cb) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { loaded = true; render(c); if (cb) cb(c); })
          .catch(function () {});
      }
      function changeQty(key, qty) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }
      function addVariant(id, qty, cb) {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
          .then(function (r) { return r.json(); })
          .then(function () { getCart(cb); })
          .catch(function () {});
      }

      // Abrir/cerrar
      if (overlay) overlay.addEventListener('click', close);
      var closers = root.querySelectorAll('[data-cart-close]');
      for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      // API por eventos: otras secciones pueden agregar al carrito y abrir el drawer
      document.addEventListener('ms-cart:add', function (e) {
        var id = e.detail && e.detail.id;
        var qty = (e.detail && e.detail.quantity) || 1;
        if (!id) return;
        addVariant(id, qty, function () { open(); });
      });
      document.addEventListener('ms-cart:open', function () { getCart(function () { open(); }); });

      // Interceptar clics a la página del carrito y botones marcados
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) { e.preventDefault(); getCart(); open(); return; }
        var link = e.target.closest('a');
        if (link && link.getAttribute('href')) {
          var a = document.createElement('a');
          a.href = link.href;
          if (/\/cart\/?$/.test(a.pathname) && !link.hasAttribute('data-no-drawer')) {
            e.preventDefault();
            getCart();
            open();
          }
        }
      });

      // Interceptar agregar al carrito (forms del sitio) → AJAX + abrir
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;
        e.preventDefault();
        var fd = new FormData(form);
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function () { getCart(function () { if (openOnAdd) open(); }); })
          .catch(function () {})
          .then(function () { if (btn) btn.disabled = false; });
      });

      // Completa tu combo (Pre-Work Out): sugiere el siguiente peldaño de la escalera según lo que ya está en el carrito
      var comboWrap = root.querySelector('[data-pwo-combo]');
      var comboList = root.querySelector('[data-pwo-combo-lista]');
      var pwoVars = [];
      try { var pvEl = root.querySelector('[data-pwo-variantes]'); if (pvEl) pwoVars = JSON.parse(pvEl.textContent); } catch (e) { pwoVars = []; }
      function varPorSku(sku) { for (var i = 0; i < pwoVars.length; i++) { if (pwoVars[i].sku === sku) return pwoVars[i]; } return null; }
      function sugerencias(item) {
        var sku = item.sku || '', s = [];
        var m = /^PWO-(MORA|SANDIA|MANGO|MANGOCH)-(3|20)$/.exec(sku);
        function add(v, titulo, sub) { if (v && v.available && v.id !== item.variant_id) s.push({ v: v, titulo: titulo, sub: sub }); }
        if (m && m[2] === '3') {
          if (m[1] === 'MORA' || m[1] === 'SANDIA') {
            var duo = varPorSku('PWO-DUO');
            add(duo, 'Agrega ' + (m[1] === 'MORA' ? 'Sandía' : 'Mora Azul'), 'Un sobre de cada sabor · el dúo sale a ' + (duo ? formatMoney(duo.price, fmt) : ''));
          }
          var bolsa = varPorSku('PWO-' + m[1] + '-20');
          add(bolsa, 'Cámbialo por la bolsa', '20 gomitas · ' + (bolsa ? formatMoney(bolsa.price / 20, fmt) + ' por gomita' : ''));
        } else if (sku === 'PWO-DUO') {
          add(varPorSku('PWO-2B-MIX'), 'Llévate 2 bolsas', 'Una de cada sabor · envío gratis incluido');
          add(varPorSku('PWO-MORA-20'), 'Cámbialo por la bolsa', '20 gomitas Mora Azul');
        } else if (m && m[2] === '20') {
          add(varPorSku('PWO-2B-' + m[1]), 'Llévate 2 bolsas', '40 gomitas · envío gratis incluido');
          add(varPorSku('PWO-2B-MIX'), 'Una bolsa de cada sabor', '2 bolsas · envío gratis incluido');
        }
        return s.slice(0, 2);
      }
      function renderCombo(cart) {
        if (!comboWrap || !comboList) return;
        var item = null;
        for (var i = 0; i < cart.items.length; i++) { if (/^PWO-/.test(cart.items[i].sku || '')) { item = cart.items[i]; break; } }
        var s = item ? sugerencias(item) : [];
        if (!s.length) { comboWrap.hidden = true; comboList.innerHTML = ''; return; }
        var h = '';
        for (var j = 0; j < s.length; j++) {
          var dif = s[j].v.price - item.final_price;
          var precio = (dif > 0 && dif < s[j].v.price) ? '+ ' + formatMoney(dif, fmt) : formatMoney(s[j].v.price, fmt);
          h += '<div class="ms-cart__combo-card' + (j === s.length - 1 ? ' ms-cart__combo-card--mejor' : '') + '">' +
            (s[j].v.img ? '<img src="' + esc(s[j].v.img) + '" alt="" loading="lazy">' : '<span></span>') +
            '<div><b>' + esc(s[j].titulo) + '</b><small>' + esc(s[j].sub) + '</small></div>' +
            '<button type="button" data-combo-id="' + s[j].v.id + '" data-combo-key="' + esc(item.key) + '" data-combo-qty="' + item.quantity + '">' + precio + '</button></div>';
        }
        comboList.innerHTML = h;
        comboWrap.hidden = false;
      }
      function replaceLine(key, newId, qty) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: newId, quantity: qty || 1 }) }); })
          .then(function () { getCart(); })
          .catch(function () { getCart(); });
      }
      if (comboWrap) {
        comboWrap.addEventListener('click', function (e) {
          var b = e.target.closest('[data-combo-id]');
          if (!b) return;
          b.disabled = true;
          replaceLine(b.getAttribute('data-combo-key'), parseInt(b.getAttribute('data-combo-id'), 10), parseInt(b.getAttribute('data-combo-qty'), 10) || 1);
        });
      }
      root.__msCartRender = render;

      // Items: +/- y eliminar
      itemsEl.addEventListener('click', function (e) {
        var inc = e.target.closest('[data-inc]');
        var dec = e.target.closest('[data-dec]');
        var rem = e.target.closest('[data-remove]');
        if (inc) { changeQty(inc.getAttribute('data-key'), (parseInt(inc.getAttribute('data-qty'), 10) || 1) + 1); }
        else if (dec) { var q = (parseInt(dec.getAttribute('data-qty'), 10) || 1) - 1; changeQty(dec.getAttribute('data-key'), q < 0 ? 0 : q); }
        else if (rem) { changeQty(rem.getAttribute('data-key'), 0); }
      });

      // Upsells quick add
      if (upsellsWrap) {
        upsellsWrap.addEventListener('click', function (e) {
          var b = e.target.closest('[data-upsell-add]');
          if (!b) return;
          e.preventDefault();
          var original = b.textContent;
          b.disabled = true; b.textContent = '✓ Agregado';
          addVariant(b.getAttribute('data-id'), 1, function () {
            if (openOnAdd) open();
            setTimeout(function () { b.disabled = false; b.textContent = original; }, 1200);
          });
        });
      }

      // Código de descuento
      function setMsg(text, type) {
        if (!discMsg) return;
        discMsg.textContent = text || '';
        discMsg.className = 'ms-cart__discount-msg' + (type ? ' is-' + type : '');
      }
      function applyDiscount(code) {
        if (!code) { setMsg('Escribe un código.', 'err'); return; }
        if (discApply) discApply.disabled = true;
        setMsg('Aplicando…', '');
        function done(cart) {
          render(cart);
          var ok = (cart.total_discount > 0) || ((cart.cart_level_discount_applications || cart.discount_applications || []).length > 0);
          setMsg(ok ? '✓ ¡Código aplicado!' : 'Código no válido o no aplicable a tu carrito.', ok ? 'ok' : 'err');
          if (discApply) discApply.disabled = false;
        }
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            var cart = null;
            try { cart = JSON.parse(t); } catch (e) { cart = null; }
            if (cart && typeof cart.item_count !== 'undefined') { done(cart); }
            else { getCart(done); }
          })
          .catch(function () { getCart(done); });
      }
      if (discToggle && discForm) {
        discToggle.addEventListener('click', function () {
          var hidden = discForm.hasAttribute('hidden');
          if (hidden) { discForm.removeAttribute('hidden'); discToggle.setAttribute('aria-expanded', 'true'); if (discInput) discInput.focus(); }
          else { discForm.setAttribute('hidden', ''); discToggle.setAttribute('aria-expanded', 'false'); }
        });
      }
      if (discApply && discInput) {
        discApply.addEventListener('click', function () { applyDiscount(discInput.value.trim()); });
        discInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(discInput.value.trim()); } });
      }
    }

    function initAll() {
      var all = document.querySelectorAll('.ms-cart');
      for (var i = 0; i < all.length; i++) initCart(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-cierre"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-copiar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ok = b.querySelector('[data-copiado]');
        var fin = function () { if (!ok) return; ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 1600); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(b.getAttribute('data-copiar')).then(fin, fin); } else { fin(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.__msFaqInit) return;
      root.__msFaqInit = true;
      if (root.getAttribute('data-single') !== 'true') return;
      var items = root.querySelectorAll('.ms-faq__item');
      for (var i = 0; i < items.length; i++) {
        (function (d) {
          d.addEventListener('toggle', function () {
            if (!d.open) return;
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== d && items[j].open) items[j].removeAttribute('open');
            }
          });
        })(items[i]);
      }
    }
    function initAll() {
      var all = document.querySelectorAll('.ms-faq');
      for (var i = 0; i < all.length; i++) initFaq(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(root) {
      if (root.__msHdInit) return;
      root.__msHdInit = true;

      function openDrawer() { root.classList.add('is-drawer-open'); document.documentElement.style.overflow = 'hidden'; }
      function closeDrawer() { root.classList.remove('is-drawer-open'); document.documentElement.style.overflow = ''; }

      var openers = root.querySelectorAll('[data-drawer-open]');
      for (var i = 0; i < openers.length; i++) openers[i].addEventListener('click', openDrawer);
      var closers = root.querySelectorAll('[data-drawer-close]');
      for (var j = 0; j < closers.length; j++) closers[j].addEventListener('click', closeDrawer);

      var subToggles = root.querySelectorAll('[data-submenu-toggle]');
      for (var s = 0; s < subToggles.length; s++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var li = btn.parentNode;
            var sub = li.querySelector('.ms-hd__submenu');
            var isOpen = btn.classList.toggle('is-open');
            if (sub) { if (isOpen) { sub.classList.add('is-open'); } else { sub.classList.remove('is-open'); } }
          });
        })(subToggles[s]);
      }

      var searchToggles = root.querySelectorAll('[data-search-toggle]');
      var searchBar = root.querySelector('.ms-hd__search');
      for (var t = 0; t < searchToggles.length; t++) {
        searchToggles[t].addEventListener('click', function () {
          if (!searchBar) return;
          var isOpen = searchBar.classList.toggle('is-open');
          if (isOpen) { var inp = searchBar.querySelector('input'); if (inp) inp.focus(); }
        });
      }

      var announce = root.querySelector('.ms-hd__announce');
      if (announce && announce.getAttribute('data-autoplay') === 'true') {
        var items = announce.querySelectorAll('.ms-hd__announce-item');
        if (items.length > 1) {
          announce.classList.add('has-rotation');
          var idx = 0;
          items[0].classList.add('is-active');
          var speed = (parseFloat(announce.getAttribute('data-speed')) || 4) * 1000;
          setInterval(function () {
            items[idx].classList.remove('is-active');
            idx = (idx + 1) % items.length;
            items[idx].classList.add('is-active');
          }, speed);
        }
      }

      if (root.getAttribute('data-sticky') === 'true') {
        var onScroll = function () {
          if (window.scrollY > 4) { root.classList.add('is-scrolled'); } else { root.classList.remove('is-scrolled'); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }

    function initAll() {
      var all = document.querySelectorAll('.ms-hd');
      for (var i = 0; i < all.length; i++) initHeader(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-hero-venta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hero-venta]');
    if (!root) return;
    var btn = root.querySelector('[data-hero-venta-btn]');
    var tab = root.querySelector('[data-hero-venta-tab]');
    var flot = root.querySelector('[data-hero-venta-flot]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var pasado = false, cierreVisible = false;
    var pintar = function () {
      var mostrar = pasado && !cierreVisible;
      if (tab) tab.hidden = !mostrar;
      if (flot) flot.hidden = !mostrar;
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
      pintar();
    }, { threshold: 0 }).observe(btn);
    var cierre = document.querySelector('.ms-ci, .ms-ft2');
    if (cierre) {
      new IntersectionObserver(function (entries) { cierreVisible = entries[0].isIntersecting; pintar(); }, { threshold: 0.15 }).observe(cierre);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DEFAULT_FMT = '$' + '{' + '{amount}}';
    function formatMoney(cents, format) {
      format = format || DEFAULT_FMT;
      function fmt(num, precision, thousands, decimal) {
        if (num == null || isNaN(num)) num = 0;
        var val = (num / 100).toFixed(precision);
        var parts = val.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholder);
      var value;
      switch (match && match[1]) {
        case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
        default: value = fmt(cents, 2, ',', '.');
      }
      return format.replace(placeholder, value);
    }

    function initProduct(root) {
      if (root.__msPpInit) return;
      root.__msPpInit = true;

      var fmt = root.getAttribute('data-money-format') || DEFAULT_FMT;
      var dataEl = root.querySelector('[data-variants]');
      var variants = [];
      if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

      var opts = root.querySelectorAll('[data-opt]');
      var idInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add]');
      var priceNow = root.querySelector('[data-price-now]');
      var priceWas = root.querySelector('[data-price-was]');
      var badge = root.querySelector('[data-badge]');
      var mainImg = root.querySelector('[data-main-img]');

      function chosen() {
        var groups = {};
        for (var i = 0; i < opts.length; i++) {
          var inp = opts[i];
          if (inp.checked) { groups[inp.getAttribute('data-opt-index')] = inp.value; }
        }
        var keys = Object.keys(groups).sort(function (a, b) { return a - b; });
        var arr = [];
        for (var k = 0; k < keys.length; k++) arr.push(groups[keys[k]]);
        return arr;
      }

      function match(sel) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          if (sel[0] != null && v.option1 !== sel[0]) ok = false;
          if (sel[1] != null && v.option2 !== sel[1]) ok = false;
          if (sel[2] != null && v.option3 !== sel[2]) ok = false;
          if (ok) return v;
        }
        return null;
      }

      function syncLabels() {
        var labels = root.querySelectorAll('[data-opt-label]');
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].checked) {
            var idx = opts[i].getAttribute('data-opt-index');
            for (var j = 0; j < labels.length; j++) {
              if (labels[j].getAttribute('data-opt-label') === idx) labels[j].textContent = opts[i].value;
            }
          }
        }
      }

      function update() {
        syncLabels();
        var v = match(chosen());
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.getAttribute('data-add-label') || 'Agregar') : 'Agotado';
        }
        if (priceNow) {
          priceNow.textContent = formatMoney(v.price, fmt);
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          if (onSale) { priceNow.classList.add('ms-pp__price-now--sale'); } else { priceNow.classList.remove('ms-pp__price-now--sale'); }
          if (priceWas) {
            if (onSale) { priceWas.textContent = formatMoney(v.compare_at_price, fmt); priceWas.style.display = ''; }
            else { priceWas.style.display = 'none'; }
          }
          if (badge) {
            if (onSale) { badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; badge.style.display = ''; }
            else { badge.style.display = 'none'; }
          }
        }
        if (mainImg && v.featured_image && v.featured_image.src) {
          mainImg.src = v.featured_image.src;
        }
      }

      for (var i = 0; i < opts.length; i++) opts[i].addEventListener('change', update);
      update();

      var thumbs = root.querySelectorAll('[data-thumb]');
      for (var t = 0; t < thumbs.length; t++) {
        (function (th) {
          th.addEventListener('click', function () {
            if (mainImg) mainImg.src = th.getAttribute('data-full');
            for (var x = 0; x < thumbs.length; x++) thumbs[x].classList.remove('is-active');
            th.classList.add('is-active');
          });
        })(thumbs[t]);
      }

      var qInput = root.querySelector('[data-qty-input]');
      var qMinus = root.querySelector('[data-qty-minus]');
      var qPlus = root.querySelector('[data-qty-plus]');
      if (qInput && qMinus) qMinus.addEventListener('click', function () { var n = parseInt(qInput.value, 10) || 1; if (n > 1) qInput.value = n - 1; });
      if (qInput && qPlus) qPlus.addEventListener('click', function () { var n = parseInt(qInput.value, 10) || 1; qInput.value = n + 1; });
    }

    function initAll() {
      var all = document.querySelectorAll('.ms-pp');
      for (var i = 0; i < all.length; i++) initProduct(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-pwo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function crearDinero(formato) {
      return function (centavos, sinCeros) {
        var c = Math.round(centavos);
        function num(dec, mil, sep) {
          var partes = (c / 100).toFixed(dec).split('.');
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
          return partes[1] ? partes[0] + sep + partes[1] : partes[0];
        }
        var texto = (formato || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, clave) {
          if (clave === 'amount_no_decimals') return num(0, ',', '.');
          if (clave === 'amount_with_comma_separator') return num(2, '.', ',');
          if (clave === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
          if (clave === 'amount_with_apostrophe_separator') return num(2, "'", '.');
          return num(2, ',', '.');
        });
        return sinCeros ? texto.replace(/[.,]00(?!\d)/, '') : texto;
      };
    }

    function iniciar(raiz) {
      if (!raiz || raiz.__pwo) return;
      raiz.__pwo = true;
      var q = function (sel, el) { return (el || raiz).querySelector(sel); };
      var qq = function (sel, el) { return Array.prototype.slice.call((el || raiz).querySelectorAll(sel)); };
      var dinero = crearDinero(raiz.getAttribute('data-formato-dinero'));
      var TXT_BOTON = raiz.getAttribute('data-texto-boton') || 'Agregar al carrito';
      var TXT_AGOTADO = raiz.getAttribute('data-texto-agotado') || 'Agotado';

      var form = q('[data-pwo-form]');
      var inputId = q('[data-pwo-id]');
      var cant = q('[data-pwo-cant]');
      var boton = q('[data-pwo-boton]');
      var error = q('[data-pwo-error]');
      var precio = q('[data-pwo-precio]');
      var precioDet = q('[data-pwo-precio-detalle]');
      var pasoSabor = q('[data-pwo-paso-sabor]');
      var saborNombre = q('[data-pwo-sabor-nombre]');
      var escena = q('.ms-pwo__escena-img');
      var sticker = q('[data-pwo-sticker]');
      var minis = qq('[data-pwo-mini]');
      var formatos = qq('[data-formato]');
      var grupos = qq('[data-grupo-sabores]');
      var pega = q('[data-pwo-pega]');
      var pegaImg = q('[data-pwo-pega-img]');
      var pegaTit = q('[data-pwo-pega-titulo]');
      var pegaDet = q('[data-pwo-pega-detalle]');
      var pegaBtn = q('[data-pwo-pega-btn]');
      if (!form || !inputId || !boton || !formatos.length) return;

      function formatoSel() { return formatos.filter(function (f) { return f.classList.contains('is-sel'); })[0] || formatos[0]; }
      function grupoDe(f) {
        var id = f.getAttribute('data-formato');
        return grupos.filter(function (g) { return g.getAttribute('data-grupo-sabores') === id; })[0];
      }
      function opciones(g) { return g ? qq('[data-variante]', g) : []; }
      function varianteSel() {
        var ops = opciones(grupoDe(formatoSel()));
        return ops.filter(function (b) { return b.classList.contains('is-sel'); })[0] || ops[0];
      }
      function marcar(lista, el) {
        lista.forEach(function (x) {
          var on = x === el;
          x.classList.toggle('is-sel', on);
          x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      function cantidad() {
        var n = parseInt(cant.value, 10);
        n = isNaN(n) ? 1 : Math.max(1, Math.min(10, n));
        cant.value = n;
        return n;
      }
      function mostrarMedia(id) {
        var mini = minis.filter(function (m) { return m.getAttribute('data-media') === String(id); })[0];
        if (!mini || !escena) return;
        if (escena.getAttribute('data-media') !== String(id)) {
          escena.setAttribute('srcset', mini.getAttribute('data-srcset'));
          escena.setAttribute('src', mini.getAttribute('data-src'));
          escena.setAttribute('alt', mini.getAttribute('data-alt') || '');
          escena.setAttribute('data-media', String(id));
        }
        minis.forEach(function (m) { m.classList.toggle('is-sel', m === mini); });
      }
      function filtrarMinis(clave, todas) {
        minis.forEach(function (m) {
          var g = m.getAttribute('data-grupo');
          m.hidden = !(todas || !clave || g === clave || g === 'general');
        });
      }

      function actualizar(opc) {
        opc = opc || {};
        var f = formatoSel();
        var g = grupoDe(f);
        grupos.forEach(function (x) { x.hidden = x !== g; });
        var v = varianteSel();
        if (!v) return;
        var id = v.getAttribute('data-variante');
        var p = parseInt(v.getAttribute('data-precio'), 10) || 0;
        var disp = v.getAttribute('data-disponible') === 'true';
        var gom = parseInt(f.getAttribute('data-gomitas'), 10) || 1;
        var unico = opciones(g).length === 1;
        var n = cantidad();
        inputId.value = id;
        if (precio) precio.textContent = dinero(p, true);
        if (precioDet) precioDet.textContent = [f.getAttribute('data-titulo'), f.getAttribute('data-detalle'), dinero(p / gom) + ' por gomita'].filter(Boolean).join(' · ');
        if (pasoSabor) pasoSabor.textContent = pasoSabor.getAttribute(unico ? 'data-texto-unico' : 'data-texto-elegir');
        if (saborNombre) saborNombre.textContent = unico ? '' : v.getAttribute('data-nombre');
        boton.disabled = !disp;
        boton.textContent = disp ? TXT_BOTON + ' · ' + dinero(p * n, true) : TXT_AGOTADO;
        var st = f.getAttribute('data-sticker') || '';
        if (sticker) { sticker.textContent = st; sticker.hidden = !st; }
        filtrarMinis(v.getAttribute('data-clave'), v.getAttribute('data-todas') === 'true');
        if (opc.media !== false) {
          var mid = v.getAttribute('data-media');
          if (mid) mostrarMedia(mid);
        }
        qq('[data-pwo-agregar]').forEach(function (el) {
          if (el.classList.contains('ms-pwo__peldano-bt')) el.parentNode.classList.toggle('is-sel', el.getAttribute('data-pwo-agregar') === f.getAttribute('data-formato'));
        });
        if (pega) {
          var mini = v.getAttribute('data-mini');
          if (pegaImg && mini) pegaImg.setAttribute('src', mini);
          if (pegaTit) pegaTit.textContent = unico ? f.getAttribute('data-titulo') : v.getAttribute('data-nombre') + ' · ' + f.getAttribute('data-titulo');
          if (pegaDet) pegaDet.textContent = f.getAttribute('data-detalle') + ' · ' + dinero(p, true);
          if (pegaBtn) {
            pegaBtn.disabled = !disp;
            pegaBtn.textContent = disp ? (pegaBtn.getAttribute('data-texto') || 'Agregar') : TXT_AGOTADO;
          }
        }
        if (opc.url) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', id);
            window.history.replaceState(window.history.state, '', u.toString());
          } catch (e) {}
        }
        if (error) error.hidden = true;
      }

      function elegirFormato(f) {
        var previo = varianteSel();
        var sabor = previo && previo.getAttribute('data-sabor');
        marcar(formatos, f);
        var ops = opciones(grupoDe(f));
        var elegido = ops.filter(function (b) { return b.getAttribute('data-sabor') === sabor; })[0]
          || ops.filter(function (b) { return b.getAttribute('data-disponible') === 'true'; })[0]
          || ops[0];
        marcar(ops, elegido);
      }
      function formatoPorId(id) { return formatos.filter(function (x) { return x.getAttribute('data-formato') === id; })[0]; }
      function enviar() { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else boton.click(); }

      formatos.forEach(function (f) {
        f.addEventListener('click', function () { elegirFormato(f); actualizar({ url: true }); });
      });
      grupos.forEach(function (g) {
        opciones(g).forEach(function (b) {
          b.addEventListener('click', function () { marcar(opciones(g), b); actualizar({ url: true }); });
        });
      });
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrarMedia(m.getAttribute('data-media')); });
      });
      var menos = q('[data-pwo-menos]');
      var mas = q('[data-pwo-mas]');
      if (menos) menos.addEventListener('click', function () { cant.value = cantidad() - 1; actualizar({ media: false }); });
      if (mas) mas.addEventListener('click', function () { cant.value = cantidad() + 1; actualizar({ media: false }); });
      cant.addEventListener('change', function () { actualizar({ media: false }); });

      qq('[data-pwo-ir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var destino = q('[data-variante="' + btn.getAttribute('data-pwo-ir') + '"]');
          if (!destino) return;
          var g = destino.closest('[data-grupo-sabores]');
          var f = formatoPorId(g.getAttribute('data-grupo-sabores'));
          if (f) marcar(formatos, f);
          marcar(opciones(g), destino);
          actualizar({ url: true });
          var compra = q('.ms-pwo__compra');
          var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (compra) compra.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
        });
      });
      // escalera y cierre: eligen la presentación (con el sabor actual) y agregan al carrito
      qq('[data-pwo-agregar]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = formatoPorId(btn.getAttribute('data-pwo-agregar'));
          if (!f) return;
          elegirFormato(f);
          actualizar({ url: true });
          enviar();
        });
      });

      // Agregar: /cart/add.js con manejo de errores; el carrito lateral (ms-cart-drawer) se abre con ms-cart:open
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        e.stopPropagation();
        if (boton.disabled) return;
        var n = cantidad();
        var raizRutas = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        boton.disabled = true;
        boton.classList.add('is-cargando');
        fetch(raizRutas + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(inputId.value, 10), quantity: n }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            boton.classList.remove('is-cargando');
            actualizar({ media: false });
            if (!res.ok) {
              if (error) {
                error.textContent = (res.d && (res.d.description || res.d.message)) || 'No se pudo agregar al carrito. Intenta de nuevo.';
                error.hidden = false;
              }
              return;
            }
            if (document.querySelector('.ms-cart')) document.dispatchEvent(new CustomEvent('ms-cart:open'));
            else window.location.href = raizRutas + 'cart';
          })
          .catch(function () {
            boton.classList.remove('is-cargando');
            actualizar({ media: false });
            if (error) {
              error.textContent = 'No se pudo agregar al carrito. Revisa tu conexión e intenta de nuevo.';
              error.hidden = false;
            }
          });
      });

      // Barra fija: aparece cuando el botón principal ya quedó arriba de la pantalla
      var accion = q('.ms-pwo__accion');
      if (pega && accion && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            var ver = !en.isIntersecting && en.boundingClientRect.top < 0;
            pega.classList.toggle('is-visible', ver);
            pega.setAttribute('aria-hidden', ver ? 'false' : 'true');
            if ('inert' in pega) pega.inert = !ver;
          });
        }).observe(accion);
        if (pegaBtn) pegaBtn.addEventListener('click', enviar);
      }
      // La barra inferior del tema (ms-bottombar) queda encima; la barra fija se acomoda sobre ella
      function medirNav() {
        var nav = document.querySelector('.ms-bnav');
        document.documentElement.style.setProperty('--pwo-bnav-h', (nav ? nav.offsetHeight : 0) + 'px');
      }
      medirNav();
      window.addEventListener('resize', medirNav);

      // ?sabor=xxx (clave de imagen del sabor): preselecciona ese sabor si el enlace no trae variant=
      try {
        var params = new URLSearchParams(window.location.search);
        var claveUrl = params.get('sabor');
        if (claveUrl && !params.get('variant')) {
          var g0 = grupoDe(formatoSel());
          var cand = opciones(g0).filter(function (b) { return b.getAttribute('data-clave') === claveUrl; })[0];
          if (cand) marcar(opciones(g0), cand);
        }
      } catch (e) {}

      actualizar({ media: true });
    }

    function arrancar() { document.querySelectorAll('[data-pwo]').forEach(iniciar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-pwo]');
      if (r) iniciar(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      if (root.__msQuizInit) return;
      root.__msQuizInit = true;

      var panel = root.querySelector('.ms-quiz__panel');
      var resultsPanel = root.querySelector('.ms-quiz__results');
      var steps = Array.prototype.slice.call(root.querySelectorAll('.ms-quiz__step'));
      var results = Array.prototype.slice.call(root.querySelectorAll('.ms-quiz__result'));
      var nextBtn = root.querySelector('.ms-quiz__next');
      var backBtn = root.querySelector('.ms-quiz__back');
      var fill = root.querySelector('.ms-quiz__progress-fill');
      var counter = root.querySelector('.ms-quiz__counter');
      var restartBtns = root.querySelectorAll('.ms-quiz__restart');
      var nextText = nextBtn ? nextBtn.getAttribute('data-next') : 'Siguiente';
      var finishText = nextBtn ? nextBtn.getAttribute('data-finish') : 'Ver mi match';

      var total = steps.length;
      var current = 0;
      var choices = [];
      var i;
      for (i = 0; i < total; i++) choices.push(null);

      function update() {
        for (var s = 0; s < steps.length; s++) {
          steps[s].style.display = (s === current) ? 'block' : 'none';
        }
        var pct = total ? Math.round(((current + 1) / total) * 100) : 0;
        if (fill) fill.style.width = pct + '%';
        if (counter) counter.textContent = (current + 1) + '/' + total;
        if (backBtn) backBtn.style.visibility = (current > 0) ? 'visible' : 'hidden';

        var step = steps[current];
        if (step) {
          var opts = step.querySelectorAll('.ms-quiz__option');
          for (var o = 0; o < opts.length; o++) {
            var sel = opts[o].getAttribute('data-result') === choices[current];
            if (sel) { opts[o].classList.add('is-selected'); }
            else { opts[o].classList.remove('is-selected'); }
          }
        }
        if (nextBtn) {
          nextBtn.disabled = !choices[current];
          var label = nextBtn.querySelector('.ms-quiz__next-label');
          if (label) label.textContent = (current === total - 1) ? finishText : nextText;
        }
      }

      for (var idx = 0; idx < steps.length; idx++) {
        (function (stepIndex) {
          var opts = steps[stepIndex].querySelectorAll('.ms-quiz__option');
          for (var k = 0; k < opts.length; k++) {
            opts[k].addEventListener('click', function () {
              choices[stepIndex] = this.getAttribute('data-result');
              var siblings = steps[stepIndex].querySelectorAll('.ms-quiz__option');
              for (var m = 0; m < siblings.length; m++) siblings[m].classList.remove('is-selected');
              this.classList.add('is-selected');
              if (stepIndex === current && nextBtn) nextBtn.disabled = false;
            });
          }
        })(idx);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (!choices[current]) return;
          if (current < total - 1) {
            current++;
            update();
          } else {
            finish();
          }
        });
      }
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (current > 0) { current--; update(); }
        });
      }

      function finish() {
        var tally = {};
        for (var c = 0; c < choices.length; c++) {
          var key = choices[c];
          if (key) tally[key] = (tally[key] || 0) + 1;
        }
        var best = null, bestN = -1;
        for (var t in tally) { if (tally[t] > bestN) { bestN = tally[t]; best = t; } }
        var target = null;
        for (var r = 0; r < results.length; r++) {
          if (results[r].getAttribute('data-key') === best) target = results[r];
        }
        if (!target && results.length) target = results[0];
        for (var rr = 0; rr < results.length; rr++) {
          results[rr].style.display = (results[rr] === target) ? 'block' : 'none';
        }
        if (panel) panel.style.display = 'none';
        if (resultsPanel) resultsPanel.hidden = false;
      }

      for (var b = 0; b < restartBtns.length; b++) {
        restartBtns[b].addEventListener('click', function () {
          for (var z = 0; z < total; z++) choices[z] = null;
          current = 0;
          var selected = root.querySelectorAll('.ms-quiz__option.is-selected');
          for (var y = 0; y < selected.length; y++) selected[y].classList.remove('is-selected');
          if (resultsPanel) resultsPanel.hidden = true;
          if (panel) panel.style.display = '';
          update();
        });
      }

      update();
    }

    function initAll() {
      var all = document.querySelectorAll('.ms-quiz');
      for (var i = 0; i < all.length; i++) initQuiz(all[i]);
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (root.__msReviewsInit) return;
      root.__msReviewsInit = true;
      var track = root.querySelector('.ms-reviews__track');
      if (!track) return;
      var prev = root.querySelector('.ms-reviews__arrow--prev');
      var next = root.querySelector('.ms-reviews__arrow--next');

      function stepSize() {
        var card = track.querySelector('.ms-reviews__card');
        if (card) return card.getBoundingClientRect().width + 16;
        return track.clientWidth * 0.8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });

      function updateArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }
      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }
    function initAll() {
      var all = document.querySelectorAll('.ms-reviews');
      for (var i = 0; i < all.length; i++) initReviews(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-tres-fotos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tres-fotos]').forEach(function (root) {
      var lista = root.querySelector('[data-tf-lista]');
      var dots = root.querySelectorAll('[data-tf-dots] span');
      if (!lista || !dots.length) return;
      var t = null;
      lista.addEventListener('scroll', function () {
        if (t) return;
        t = setTimeout(function () {
          t = null;
          var cards = lista.children, centro = lista.scrollLeft + lista.clientWidth / 2, mejor = 0, dist = Infinity;
          for (var i = 0; i < cards.length; i++) {
            var c = cards[i].offsetLeft + cards[i].offsetWidth / 2, d = Math.abs(c - centro);
            if (d < dist) { dist = d; mejor = i; }
          }
          dots.forEach(function (s, i) { s.classList.toggle('is-on', i === mejor); });
        }, 80);
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esc(s) {
      return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function initUGC(root) {
      if (root.__msUgcInit) return;
      root.__msUgcInit = true;

      var cta = root.getAttribute('data-cta') || 'Ver producto';
      var track = root.querySelector('[data-ugc-track]');
      var cards = [].slice.call(root.querySelectorAll('[data-ugc-card]'));
      var viewer = root.querySelector('[data-ugc-viewer]');
      var vMedia = root.querySelector('[data-ugc-viewer-media]');
      var vInfo = root.querySelector('[data-ugc-viewer-info]');
      var current = 0;

      function buildMedia(card) {
        var mp4 = card.getAttribute('data-mp4');
        var embed = card.getAttribute('data-embed');
        var poster = card.getAttribute('data-poster');
        if (mp4) {
          return '<video src="' + mp4 + '" controls autoplay playsinline preload="auto"' + (poster ? ' poster="' + poster + '"' : '') + '></video>';
        }
        if (embed) {
          return '<iframe src="' + embed + '" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>';
        }
        if (poster) { return '<img src="' + poster + '" alt="">'; }
        return '';
      }

      function buildInfo(card) {
        var handle = card.getAttribute('data-handle');
        var caption = card.getAttribute('data-caption');
        var purl = card.getAttribute('data-product-url');
        var variant = card.getAttribute('data-product-variant');
        var avail = card.getAttribute('data-product-available');
        var html = '';
        if (handle) { html += '<div class="ms-ugc__viewer-handle">' + esc(handle) + '</div>'; }
        if (caption) { html += '<p class="ms-ugc__viewer-caption">' + esc(caption) + '</p>'; }
        if (purl || variant) {
          var pimg = card.getAttribute('data-product-img');
          var ptitle = card.getAttribute('data-product-title') || 'Producto';
          var pprice = card.getAttribute('data-product-price') || '';
          html += '<button type="button" class="ms-ugc__viewer-product" data-ugc-buy data-variant="' + (variant || '') + '" data-url="' + (purl || '') + '" data-available="' + (avail || '') + '">' +
            (pimg ? '<img src="' + pimg + '" alt="">' : '') +
            '<span class="ms-ugc__viewer-product-info">' +
              '<span class="ms-ugc__viewer-product-title">' + esc(ptitle) + '</span>' +
              (pprice ? '<span class="ms-ugc__viewer-product-price">' + esc(pprice) + '</span>' : '') +
            '</span>' +
            '<span class="ms-ugc__viewer-cta">' + esc(cta) + '</span>' +
          '</button>';
        }
        return html;
      }

      function renderViewer() {
        if (!cards.length) return;
        if (current < 0) current = cards.length - 1;
        if (current >= cards.length) current = 0;
        var card = cards[current];
        vMedia.innerHTML = buildMedia(card);
        vInfo.innerHTML = buildInfo(card);
      }
      function openViewer(i) {
        current = i;
        renderViewer();
        viewer.classList.add('is-open');
        viewer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      function closeViewer() {
        viewer.classList.remove('is-open');
        viewer.setAttribute('aria-hidden', 'true');
        vMedia.innerHTML = '';
        document.documentElement.style.overflow = '';
      }
      function step(dir) { current += dir; renderViewer(); }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { openViewer(i); });
      });

      var closeBtn = root.querySelector('[data-ugc-close]');
      var overlay = root.querySelector('[data-ugc-viewer-overlay]');
      var prevBtn = root.querySelector('[data-ugc-prev]');
      var nextBtn = root.querySelector('[data-ugc-next]');
      if (closeBtn) closeBtn.addEventListener('click', closeViewer);
      if (overlay) overlay.addEventListener('click', closeViewer);
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      document.addEventListener('keydown', function (e) {
        if (!viewer.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeViewer();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });

      // Agregar al carrito desde el visor (UGC shoppable)
      if (vInfo) {
        vInfo.addEventListener('click', function (e) {
          var buy = e.target.closest('[data-ugc-buy]');
          if (!buy) return;
          e.preventDefault();
          var variant = buy.getAttribute('data-variant');
          var url = buy.getAttribute('data-url');
          var avail = buy.getAttribute('data-available');
          closeViewer();
          if (variant && avail !== 'false' && document.querySelector('.ms-cart')) {
            document.dispatchEvent(new CustomEvent('ms-cart:add', { detail: { id: variant, quantity: 1 } }));
          } else if (url) {
            window.location.href = url;
          }
        });
      }

      // Flechas de scroll del carrusel
      var scrollPrev = root.querySelector('[data-ugc-prev-scroll]');
      var scrollNext = root.querySelector('[data-ugc-next-scroll]');
      function scrollBy(dir) {
        if (!track) return;
        var card = track.querySelector('[data-ugc-card]');
        var amount = card ? (card.offsetWidth + 16) * 2 : 400;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (scrollPrev) scrollPrev.addEventListener('click', function () { scrollBy(-1); });
      if (scrollNext) scrollNext.addEventListener('click', function () { scrollBy(1); });

      // Autoplay de previews visibles (muted)
      if (root.classList.contains('ms-ugc--autoplay') && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target.querySelector('.ms-ugc__face-video');
            if (!v) return;
            if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.5 });
        cards.forEach(function (c) { io.observe(c); });
      }
    }

    function initAll() {
      var all = document.querySelectorAll('[data-ugc]');
      for (var i = 0; i < all.length; i++) initUGC(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mscollection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCol(root) {
      if (root.__msColInit) return;
      root.__msColInit = true;
      var sel = root.querySelector('[data-sort]');
      if (sel) {
        sel.addEventListener('change', function () {
          if (sel.form) { sel.form.submit(); }
        });
      }
    }
    function initAll() {
      var all = document.querySelectorAll('.ms-col');
      for (var i = 0; i < all.length; i++) initCol(all[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
